import React, { Component, PropTypes } from 'react'
import { reduxForm } from "redux-form"
import { connect } from 'react-redux'
import Modal from 'react-modal'
import styles from './documents.scss'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import {
    setCheckBox, selectVisibleItems, selectItems, filterDSDocuments, archiveDSDocumentPackages, archiveAllDSDocumentPackages, getOneDsPackageById,
    setNotification, getDsDocsAndPackages, getUpdatablePackagesList, updatePackagesFromConnective, getPaginatedPackagesList, resendClientRemainder,
    resetDSPackagesPaginationData, setAppModule, setOpenedSubmenu, setClientSubModule, getActualizedPackageForInvitation,
} from 'state/actions'
import SelectWrap from '../../components/shared/select/SelectWrap'
import RefreshBtn from '../refreshBtn'
import {
    statusExplainerPopup, customModalStyles, getStatusTranslationKey, getStatusDescriptionTranslationKey
} from './documentsHelpers'
import { canSendInvitation } from 'lib/helpers'
import { DatePicker } from 'components/shared/datePicker'
import moment from 'moment'
import i18n from 'lib/i18n'
import { isAnEmail } from 'lib/validator'
import cs from 'classnames'
import nesProp from 'nested-property'
import * as c from 'state/constants'
import LinkDocumentsModal from './linkToContractAndUploadDocuments/LinkDocumentsModal'
import DsListButtonsWrapper from './dsListButtonsWrapper'
import ReminderEmailStatusDialog from './reminderEmailStatusDialog'

const _ = i18n('dsdocuments')

@reduxForm({
    form: "DSDocumentList",
    fields: ["startDate", "endDate"],
    initialValues: {},
})
@connect(
    ({
        DSDocuments: { filter, selectValue, modalIsOpen, opened, subModule, startDate, endDate, preSortDocumentsFromClient, templates, packages,
            sortParams, pageNumber },
        app: { lang, security: { actions } },
        office: { brokers },

    }
    ) => ({ filter, sortParams, pageNumber, selectValue, modalIsOpen, opened, subModule, startDate, endDate, preSortDocumentsFromClient, lang, templates, packages, brokers, actions })
)
export default class DSDocumentList extends React.Component {
    static propTypes = {
        filter: PropTypes.string.isRequired,
        selectValue: PropTypes.string.isRequired,
        paginatedPackages: React.PropTypes.array.isRequired,
        zoomTo: React.PropTypes.func.isRequired,
        startDate: React.PropTypes.any,
        endDate: React.PropTypes.any,
        handleSubmit: React.PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)
        const brokers = nesProp.get(props, 'brokers') || []
        const staffList = []
        const brokerNumbersList = []
        let canCreateMifid = false
        const clientAccess = nesProp.get(props, 'actions')
        clientAccess.map((item, key) => {
            if (item.actionName == 'createmifid') {
                canCreateMifid = item.actionAllowed === "true" ? true : false
            }
        })
        if (brokers) {
            for (const key in brokers) {
                if (brokers[key].brokerNumber) {
                    brokerNumbersList.push(brokers[key].brokerNumber)
                }
                if (brokers[key].staff) {
                    for (const oneStaffMember of brokers[key].staff) {
                        if (!staffList.includes(oneStaffMember.userId)) {
                            staffList.push(oneStaffMember.userId)
                        }
                    }
                }
            }
        }

        this.state = {
            visibilityOf: {}, archiveIsOpen: false, statusExplainerIsOpen: false,
            updatePackagesTotal: 0,
            updatePackagesCurrentChunk: 0,
            showUpdateWaitingModal: false,
            isOpenLinkDocumentModal: false,
            itemsPerPage: 50,
            filterableFields: [
                "createdAt",
                "documentType",
                "clientName",
                "uploadedOnModule",
                "status",
                "userFullName",
                "brokerNumber",
            ],
            staffList,
            brokerNumbersList,
            inputTimeoutId: '',
            filterParam: '',
            canCreateMifid,
            reminderConfirmationModal: false,
            reminderSentSuccessFlag: false,
            invitationBlocked: false
        }
    }

    /**
    * Used to reset the selected documents in case new ticket is being processed
    * @param {*} nextProps
    */
    componentWillReceiveProps(nextProps) {
        const { isLoaded, staffList: stateStaffList, brokerNumbersList: stateBrokerNumbersList } = this.state
        if (!isLoaded && (!stateStaffList || stateStaffList.length === 0 || !stateBrokerNumbersList || stateBrokerNumbersList.length === 0) && nextProps.brokers) {
            const brokerNumbersList = []
            const staffList = []
            for (const key in nextProps.brokers) {
                if (nextProps.brokers[key].brokerNumber) {
                    brokerNumbersList.push(nextProps.brokers[key].brokerNumber)
                }
                if (nextProps.brokers[key].staff) {
                    for (const oneStaffMember of nextProps.brokers[key].staff) {
                        if (!staffList.includes(oneStaffMember.userId)) {
                            staffList.push(oneStaffMember.userId)
                        }
                    }
                }
            }
            this.initModule(staffList, brokerNumbersList)
        } else if (!isLoaded) {
            this.initModule()
        }
    }

    componentDidUpdate() {
        this.resetAlignedComponents()
        this.alignTableComponents()
    }

    componentWillUnmount() {
        const { dispatch } = this.props
        dispatch(resetDSPackagesPaginationData())
    }

    /**
     * Component did mount hook. Check and load all the dependency values, init related values.
     */
    async initModule(updateStaffList = null, updatedBrokerNumbersList = null) {
        const { dispatch, selectValue, startDate, endDate, sortParams, pageNumber, filter, preSortDocumentsFromClient } = this.props
        const { itemsPerPage, filterableFields, staffList, brokerNumbersList } = this.state
        const paginationData = {
            sortParams, pageNumber, itemsPerPage, filterableFields, filter, filterFunction: selectValue, startDate,
            endDate, staffList, brokerNumbersList, clientId: preSortDocumentsFromClient
        }
        this.setState({ isLoaded: false })

        //if we receive clientI it means we the user has navigated from client profile and we need to show all documents that require linking from client
        if (preSortDocumentsFromClient) {
            paginationData.filterFunction = 'showNotLinked'
        }

        try {
            if ((!staffList || staffList.length === 0) && updateStaffList) {
                paginationData.staffList = updateStaffList

            }
            if ((!brokerNumbersList || brokerNumbersList.length === 0) && updatedBrokerNumbersList) {
                paginationData.brokerNumbersList = updatedBrokerNumbersList

            }
            await dispatch(getPaginatedPackagesList(paginationData))
            this.setState({ staffList: paginationData.staffList, brokerNumbersList: paginationData.brokerNumbersList, isLoaded: true })

        } catch (error) {
            this.setState({ isLoaded: true })
        }
    }

    check(ev, id) {
        ev.stopPropagation()
        const { dispatch } = this.props
        dispatch(setCheckBox(id))
    }

    archiveBtn(checkedItemCount, items) {
        const { dispatch } = this.props
        const { staffList, brokerNumbersList, } = this.state

        return (
            <div className={styles.buttonContainer}>
                <input
                    onClick={async (ev) => {
                        await dispatch(archiveDSDocumentPackages(items, staffList, brokerNumbersList))
                        this.initModule()
                    }}
                    disabled={!checkedItemCount}
                    type="button"
                    className={styles.greyButton}
                    value={_("delete")}
                />
                <input
                    onClick={() => this.archiveAllPopupToggle()}
                    disabled={!(items && items.length || false)}
                    type="button"
                    className={styles.greyButton}
                    value={_("deleteAll")}
                />
            </div>
        )
    }

    archiveAllPopupToggle() {
        this.setState({ archiveIsOpen: !this.state.archiveIsOpen })
    }

    async archiveAllConfirmHandle() {
        const { dispatch, selectValue, startDate, endDate, sortParams, filter } = this.props
        const { filterableFields, staffList, brokerNumbersList } = this.state
        const paginationData = { sortParams, filterableFields, filter, filterFunction: selectValue, startDate, endDate, staffList, brokerNumbersList }
        const itemsLength = await dispatch(archiveAllDSDocumentPackages(paginationData))
        this.archiveAllPopupToggle()
        this.initModule()

        const msg = `${_('all')} ${itemsLength} ${_('documentsDeleted')}`
        dispatch(setNotification(msg, 'info'))
    }

    archiveAllPopup() {
        const { paginatedPackages } = this.props
        const filteredDocuments = paginatedPackages.filter(item => !item.hidden)
        const itemsLength = filteredDocuments && filteredDocuments.length || 0
        const titleMsg = `${_('all')} ${itemsLength} ${_('numOfSelectedMsg')}`
        const msg = `${_('doYouWantToArchiveAll')}`
        return (
            <div className={styles.documentsModalContent}>
                <span className={styles.title}>{titleMsg}</span>
                <span className={styles.message}>{msg}</span>
                <div className={styles.documentsModalButtons}>
                    <span
                        onClick={() => this.archiveAllPopupToggle()}
                        className={styles.cancel}
                    >
                        {_("cancel")}
                    </span>
                    <input
                        onClick={() => this.archiveAllConfirmHandle()}
                        type="button"
                        className={styles.greyButton + " enabled"}
                        value={_("deleteAll")}
                    />
                </div>
            </div>
        )
    }

    handleCheckAll = () => {
        const { dispatch } = this.props
        const { allSelected, visibleIds } = this

        if (!allSelected) {
            const msg = `${_('all')} ${visibleIds.length} ${_('numOfSelectedMsg')}`
            dispatch(setNotification(msg, 'info'))
        }

        dispatch(selectVisibleItems(visibleIds))
    }

    handleVisibleList = (visibleIds) => {
        const visibilityOf = {}
        for (const id of visibleIds) {
            visibilityOf[id] = true
        }
        this.visibleIds = visibleIds
        this.setState({ visibilityOf })
    }

    /**
     * This function wills handle the filter values of the form
     */
    saveForm = (data) => {
        // const { selectValue, dispatch } = this.props
        return this.onDateFilterClick(data)
        // dispatch(filterDSDocuments(selectValue, data.startDate, data.endDate))
    }

    /**
     * This function handle the status modal opening
     * @param {string} status - one doc status
     */
    onItemStatusClick(status) {
        this.setState({ statusExplainerIsOpen: status })
    }

    /**
     *
     * @param {*} value
     */
    changeResendToAddress(value) {
        // check validity
        let valid = true

        if (!value || !isAnEmail(value)) {
            valid = false
        }

        this.setState({
            resendToAddress: value,
            resendToAddressValid: valid
        })
    }

    /**
     * This function will automatically refresh from connective the necessary packages.
     */
    getRemoteUpdateByChunks(onSubmit) {
        const { dispatch } = this.props

        this.setState({ showUpdateWaitingModal: true })

        new Promise((resolveGetUpdatableCount, rejectGetUpdatableCount) => {
            return dispatch(getUpdatablePackagesList())
                .then((result) => resolveGetUpdatableCount(result))
                .catch((err) => rejectGetUpdatableCount(err))
        })
            .then(async (listOfUpdatableIds) => {

                let totalLength = listOfUpdatableIds && listOfUpdatableIds.length
                // must be numeric
                totalLength = totalLength ? totalLength * 1 : 0

                this.setState({ updatePackagesTotal: totalLength })

                if (totalLength > 0) {
                    let chunkSize = 5
                    let maxIndex = totalLength - 1
                    let fromIndex = 0
                    let toIndex = fromIndex + chunkSize
                    toIndex = ((toIndex > maxIndex) ? maxIndex : toIndex)

                    // end of loop in case when someone push the cancel on modal or all is done
                    while ((fromIndex <= maxIndex) && (this.state.showUpdateWaitingModal)) {
                        let chunkOfIds = listOfUpdatableIds.slice(fromIndex, toIndex + 1)

                        await dispatch(updatePackagesFromConnective(chunkOfIds))
                            .then((statisticsOfSuccess) => {
                                this.setState({ updatePackagesCurrentChunk: (toIndex + 1) })
                            })

                        fromIndex = fromIndex + chunkSize
                        toIndex = fromIndex + chunkSize
                        toIndex = ((toIndex > maxIndex) ? maxIndex : toIndex)
                    }
                }
            })
            .then(() => {
                return this.simpleRefresh()
            })
            .catch((err) => {
                return onSubmit()
            })
    }

    /**
     * Will handle the situation when data from status column is not level arranged with the data from documentType
     */
    alignTableComponents = () => {
        const documentTypeElements = Array.from(document.querySelectorAll('[class*="docTypeParagraph"]'))
        const docStatusElements = Array.from(document.querySelectorAll('[class*="statusParagraph"]'))
        const docTypeMap = {}
        const docStatusMap = {}
        for (const oneElem of documentTypeElements) {
            const attribute = oneElem.getAttribute('data-documentIdAttr')
            nesProp.set(docTypeMap, attribute, oneElem)
        }
        for (const oneStatusElem of docStatusElements) {
            const attribute = oneStatusElem.getAttribute('data-documentIdAttr')
            nesProp.set(docStatusMap, attribute, oneStatusElem)
        }

        for (const key in docTypeMap) {
            const docTypeHeight = docTypeMap[key].offsetHeight
            const docStatusHeight = docStatusMap[key] ? docStatusMap[key].offsetHeight : 0
            if (docTypeHeight > 0 && docStatusHeight > 0) {
                if (docStatusHeight > docTypeHeight) {
                    docTypeMap[key].style.height = `${docStatusHeight}px`
                } else if (docStatusHeight < docTypeHeight) {
                    docStatusMap[key].style.height = `${docTypeHeight}px`
                }
            }
        }
    }

    /**
     * Resets any modification to style made by alignTableComponents method
     */
    resetAlignedComponents = () => {
        const documentTypeElements = Array.from(document.querySelectorAll('[class*="docTypeParagraph"]'))
        const docStatusElements = Array.from(document.querySelectorAll('[class*="statusParagraph"]'))
        for (const oneElem of documentTypeElements) {
            oneElem.style.height = 'auto'
        }
        for (const oneStatusElem of docStatusElements) {
            oneStatusElem.style.height = 'auto'
        }
    }

    /**
   * This method will update package from connective reactivating the main sining link and opens the signing page from connective
   * @param {*} packageId
   */
    async onDirectSignButtonClick(packageId) {
        const { dispatch } = this.props
        const responseFromConnective = await dispatch(updatePackagesFromConnective([packageId]))
        if (responseFromConnective.success) {
            const dsPackage = await dispatch(getOneDsPackageById(packageId))
            let URLForSign = nesProp.get(dsPackage, "F2FSigningUrl")
            this.setState({ dsPackage })
            window.open(URLForSign, '_blank', 'noopener,noreferrer')
        }
    }

    async onSendInvitationClick(packageId) {
        const { zoomTo, dispatch } = this.props

        const dsPackage = await dispatch(getActualizedPackageForInvitation(packageId))
        if (!dsPackage.error && canSendInvitation(dsPackage)) {
            zoomTo(dsPackage, null, true)
        } else {
            this.setState({ reminderConfirmationModal: true, invitationBlocked: true })
            this.initModule()
        }
    }

    /**
     *
     * @param {function} onSubmit
     * @returns
     */
    async simpleRefresh() {
        this.initModule()
    }

    /**
     * Render waiting modal for update packages
     */
    updatePackagesModalContent() {
        const { updatePackagesTotal, updatePackagesCurrentChunk } = this.state
        return <div className={styles.documentsModalContent}>
            <span className={styles.title}>{_("waitForRefreshPackages")}</span>
            <span className={styles.message}>{_("refreshPackagesProgress") + " " + updatePackagesCurrentChunk + "/" + updatePackagesTotal}</span>
            <div className={styles.documentsModalButtons}>
                {updatePackagesTotal !== updatePackagesCurrentChunk &&
                    <span
                        onClick={() => {
                            this.setState({ showUpdateWaitingModal: false, updatePackagesTotal: 0, updatePackagesCurrentChunk: 0 })
                        }}
                        className={styles.cancel}
                    >
                        {_("cancel")}
                    </span>
                }
                {updatePackagesTotal == updatePackagesCurrentChunk &&
                    <input
                        onClick={() => {
                            this.setState({ showUpdateWaitingModal: false, updatePackagesTotal: 0, updatePackagesCurrentChunk: 0 })
                        }}
                        type="button"
                        className={styles.greenButton}
                        value={_("ok")}
                    />}
            </div>
        </div>
    }

    /**
     *
     * @param {*} dsDocument
     */
    openLinkAndUploadWizard(dsDocument) {
        this.setState({ isOpenLinkDocumentModal: dsDocument })
    }

    /**
     * Handles the sorting form packages
     * @param {*} currentSort
     * @returns
     */
    onSortChange(currentSort) {
        if (currentSort) {
            const sortParams = {
                column: currentSort.column,
                sortOrder: currentSort.direction
                // === 1? 'asc' : 'des'
            }
            const pageNumber = 0
            const { dispatch, selectValue, startDate, endDate, filter } = this.props
            const { itemsPerPage, filterableFields } = this.state
            const paginationData = { sortParams, pageNumber, itemsPerPage, filterableFields, filter, filterFunction: selectValue, startDate, endDate }
            return dispatch(getPaginatedPackagesList(paginationData))
        }
    }

    onPageChange(pageNumber) {
        if ((pageNumber || pageNumber === 0) && pageNumber > -1) {
            const { dispatch, selectValue, startDate, endDate, sortParams, filter } = this.props
            const { itemsPerPage, filterableFields, staffList, brokerNumbersList } = this.state
            const paginationData = { sortParams, pageNumber, itemsPerPage, filterableFields, filter, filterFunction: selectValue, startDate, endDate, staffList, brokerNumbersList }
            return dispatch(getPaginatedPackagesList(paginationData))
        }
    }

    onFilterSelectorChange(filterFunction) {
        const { dispatch, startDate, endDate, sortParams, filter } = this.props
        const pageNumber = 0
        const { itemsPerPage, filterableFields, staffList, brokerNumbersList } = this.state
        const paginationData = { sortParams, pageNumber, itemsPerPage, filterableFields, filter, filterFunction, startDate, endDate, staffList, brokerNumbersList }
        return dispatch(getPaginatedPackagesList(paginationData))
    }

    onDateFilterClick(data) {
        const { dispatch, selectValue, sortParams, pageNumber, filter } = this.props
        const { itemsPerPage, filterableFields, staffList, brokerNumbersList } = this.state
        const startDate = data.startDate
        const endDate = data.endDate
        const paginationData = { sortParams, pageNumber, itemsPerPage, filterableFields, filter, filterFunction: selectValue, startDate, endDate, staffList, brokerNumbersList }
        return dispatch(getPaginatedPackagesList(paginationData))
    }

    getPaginatedDataFromServer() {
        const { dispatch, selectValue, startDate, endDate, sortParams, pageNumber, filter } = this.props
        const { itemsPerPage, filterableFields, staffList, brokerNumbersList } = this.state
        const paginationData = { sortParams, pageNumber, itemsPerPage, filterableFields, filter, filterFunction: selectValue, startDate, endDate, staffList, brokerNumbersList }
        return dispatch(getPaginatedPackagesList(paginationData))
    }

    async onFilterInputChange(filterParam) {
        const { dispatch, selectValue, startDate, endDate, sortParams, pageNumber } = this.props
        const { itemsPerPage, filterableFields, staffList, brokerNumbersList } = this.state
        const paginationData = { sortParams, pageNumber, itemsPerPage, filterableFields, filter: filterParam, filterFunction: selectValue, startDate, endDate, staffList, brokerNumbersList }
        await dispatch(getPaginatedPackagesList(paginationData))
    }

    onResendRemindersClick = async (packageId) => {
        const { dispatch } = this.props

        const reminderResponse = await dispatch(resendClientRemainder(packageId))
        let reminderSentSuccessFlag = false
        if (reminderResponse && reminderResponse.success) {
            reminderSentSuccessFlag = true
        }
        this.setState({ reminderConfirmationModal: true, reminderSentSuccessFlag })
    }

    renderDocumentDescription(onePackage) {

        if (onePackage && onePackage.tarificationInfo) {

            return < div >
                <div className={styles.documentDescriptionSpan} title={onePackage.tarificationInfo.mainGroupDescription} key={'mainGroupDescription'}>- {onePackage.tarificationInfo.mainGroupDescription}</div>
                <div className={styles.documentDescriptionSpan} title={onePackage.tarificationInfo.riskDescription} key={'riskDescription'}>- {onePackage.tarificationInfo.riskDescription}</div>

            </div >
        }

        if (onePackage && onePackage.contractInfo) {

            return < div >
                <div className={styles.documentDescriptionSpan} title={onePackage.contractInfo.mainBranche} key={'mainBranche'}>- {onePackage.contractInfo.mainBranche}</div>
                <div className={styles.documentDescriptionSpan} title={onePackage.contractInfo.mainRisk} key={'mainRisk'}>- {onePackage.contractInfo.mainRisk}</div>

            </div >
        }

        if (onePackage && onePackage.claimInfo) {

            return < div >
                <div className={styles.documentDescriptionSpan} title={onePackage.claimInfo.insuranceCompany} key={'insuranceCompany'}>- {onePackage.claimInfo.insuranceCompany}</div>
                <div className={styles.documentDescriptionSpan} title={onePackage.claimInfo.qualification} key={'qualification'}>- {onePackage.claimInfo.qualification}</div>

            </div >
        }
    }

    /**
    * This function will navigate to the target module by entity id (contracts, claims)
    * @param {object} dsdocument - dsdocument record
    */
    navigateTo(dsPackage) {
        // navigateToModuleName, dynamicId, clientId, options)
        const { dispatch } = this.props
        // const { dsPackage } = this.state

        const clientId = nesProp.get(dsPackage, "clientId")
        const contractId = nesProp.get(dsPackage, "contractId")
        const claimId = nesProp.get(dsPackage, "claimId")
        const tarificationId = nesProp.get(dsPackage, "tarificationId")
        let dynamicId = clientId
        let navigateToModuleName = ''

        // navigate by uploaded on module value, not after contract or claim existence (BEWB-231)
        if (dsPackage.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS) {
            dynamicId = claimId
            navigateToModuleName = 'claims'
        }

        if (dsPackage.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT || dsPackage.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT_PREM) {
            dynamicId = contractId
            navigateToModuleName = 'contracts'
        }

        if (dsPackage.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION) {
            dynamicId = tarificationId
            navigateToModuleName = 'tarification'
        }

        // this next line of code (commented) can get clientId from oracle by contract or claim
        // getClientId(contractId, claimId).then((clientId)=>{  })

        dispatch(setAppModule(c.CLIENTS, clientId))
        dispatch(setOpenedSubmenu(
            dynamicId, {})
        )// submenuOpened: claimId, subModuleZoom: {}
        dispatch(setClientSubModule(navigateToModuleName))// subModule: 'claims' subModuleZoom: ''
    }

    clientNameAndBrokerNumber = ({ subModuleKey, clientName, brokerNumber}) => {
        if (subModuleKey === c.DS_MODULE_OFFICE) {
            return brokerNumber
        }
        return clientName
    }

    /**
     * Render hook of react.
     */
    render() {
        const { dispatch, paginatedPackages, zoomTo, selectValue, opened, totalRecords, pageNumber,
            fields: { startDate, endDate }, handleSubmit, lang, preSortDocumentsFromClient, filter } = this.props
        const { visibilityOf, archiveIsOpen, statusExplainerIsOpen, showUpdateWaitingModal,
            isOpenLinkDocumentModal, isLoaded, itemsPerPage, canCreateMifid, reminderConfirmationModal, reminderSentSuccessFlag,
            invitationBlocked } = this.state
        const checkedItemCount = paginatedPackages && paginatedPackages.reduce((sum, item) => sum + (item.checked ? 1 : 0), 0)

        const allSelected = paginatedPackages && (paginatedPackages.length > 0) && paginatedPackages.every(item => (
            visibilityOf[item.id] ? item.checked : true
        ))

        // const allSelected = false
        this.allSelected = allSelected

        let filteredDocuments = paginatedPackages && paginatedPackages.filter(item => !item.hidden).map((item) => {
            item.priority = (moment(item.createdAt).format("YYYYMMDDHHmmss"))
            return item
        })


        // Needs to be defined here so translations are updated
        const filterOptions = [
            { value: 'showAll', label: _('showAll') },
            { value: 'showDraft', label: _('showDraft') },
            { value: 'showNotSigned', label: _('showNotSigned') },
            { value: 'showSigned', label: _('showSigned') },
            { value: 'showNotLinked', label: _('showNotLinked'), },
            { value: 'toSign', label: _('toSign') }
        ]
        if (!paginatedPackages) { return false }

        const onSubmit = handleSubmit(this.saveForm)

        if (!isLoaded) {
            return (<div></div>)
        }

        return (
            <div className={`${styles.results} ${opened ? styles.hidden : 'visible'}`}>
                <Table
                    onVisibleChange={this.handleVisibleList}
                    topPaginationElemL={
                        [
                            <div key="x1z" className="filterSelectContainer">
                                <SelectWrap
                                    key="s"
                                    value={selectValue}
                                    options={filterOptions}
                                    onChange={(v) => {
                                        // dispatch(filterDSDocuments(v.value, startDate.value, endDate.value))
                                        this.onFilterSelectorChange(v.value)
                                    }}
                                    className={styles.selectStyle}
                                />
                            </div>,
                            <RefreshBtn
                                key="r"
                                onClick={() => {
                                    this.getRemoteUpdateByChunks(onSubmit)
                                }}
                            />
                        ]
                    }
                    topPaginationElemR={this.archiveBtn(checkedItemCount, filteredDocuments)}
                    middlePagination={true}
                    middlePaginationElem={[
                        <div className={styles.datePickerContainer} key={"pickerContainer"}>
                            <form onSubmit={onSubmit}>
                                <div className={`${styles.submitContainer}`}>
                                    <div className={`${styles.inputContainer}`}>
                                        <div className={`${styles.label}`}>
                                            <p>{_('fromDate')}</p>
                                        </div>
                                        <DatePicker className={styles.inputForm}
                                            {...startDate}
                                            startDate={startDate.value}
                                            endDate={endDate.value}
                                            maxDate={endDate.value}
                                        />
                                    </div>
                                    <div className={`${styles.inputContainer}`}>
                                        <div className={`${styles.label}`}>
                                            <p>{_('toDate')}</p>
                                        </div>
                                        <DatePicker
                                            className={styles.inputForm}
                                            {...endDate}
                                            startDate={startDate.value}
                                            endDate={endDate.value}
                                            minDate={startDate.value}
                                        />
                                    </div>
                                    <div className={`${styles.inputContainer}`}>
                                        <input className={`${styles.inputSubmit}`} type="button" onClick={onSubmit} value={_('filterDateBtn')} />
                                    </div>
                                </div>
                            </form>
                        </div>
                    ]}
                    filterable={[
                        "createdAt",
                        "documentType",
                        "clientName",
                        "documentLocation",
                        "status", "userFullName"
                    ]}
                    ref={el => { this.table = el }}
                    id="table"
                    className="table"
                    sortable={[
                        { column: 'createdAt', sortFunction: 'Date' },
                        'documentType',
                        'clientName',
                        'userFullName',
                        { column: 'priority', sortFunction: 'Date' },
                        'status'
                    ]}
                    defaultSort={{
                        // column: 'createdAt',
                        column: 'priority',
                        direction: 'desc',
                    }}
                    itemsPerPage={itemsPerPage}
                    pageButtonLimit={5}
                    externalPagination={{
                        totalRecords: totalRecords,
                        currentPage: pageNumber,
                        onPageChange: (pageNumber) => {
                            this.onPageChange(pageNumber)
                        },
                        onFilter: (filterParam) => {
                            const timeoutId = this.state.inputTimeoutId
                            clearTimeout(timeoutId)
                            const newTimeoutId = setTimeout(async () => {
                                this.onFilterInputChange(filterParam)
                            }, 1500)
                            this.setState({ inputTimeoutId: newTimeoutId })
                        },
                        filter: filter
                    }}
                    onSort={(currentSort) => {
                        this.onSortChange(currentSort)
                    }}
                >
                    <Thead>
                        <Th column="priority"
                            className={styles.hidden}
                        >
                            <strong>{_("priority")}</strong>
                        </Th>
                        <Th column="checkbox">
                            <input type="checkbox" checked={allSelected} onChange={(e) => {
                                this.handleCheckAll()
                            }}
                            />
                        </Th>
                        <Th column="createdAt">
                            <strong>{_("createdAt")}</strong>
                        </Th>
                        <Th column="clientName">
                            <strong>{_("clientName")}</strong>
                        </Th>
                        <Th column="userFullName">
                            <strong>{_("userFullName")}</strong>
                        </Th>
                        <Th column="documentLocation">
                            <strong>{_("documentLocation")}</strong>
                        </Th>
                        <Th column="documentDescription">
                            <strong>{_("documentDescription")}</strong>
                        </Th>
                        <Th column="documentType">
                            <strong>{_("documentType")}</strong>
                        </Th>
                        <Th column="status">
                            <strong>{_("status")}</strong>
                        </Th>
                        <Th column="actions">
                            <strong>{_("actions")}</strong>
                        </Th>
                    </Thead>
                    {filteredDocuments.map((item, key) => {
                        const trStyleArchived = item.archived ? `${styles.archived} clickable` : `clickable`
                        const documentsNames = []
                        const documentsStatuses = []
                        const status = item && item.status || ""
                        const itemStatusTranslated = _(getStatusTranslationKey(status))
                        const itemStatusTranslatedSigned = _(getStatusTranslationKey(c.DS_PACKAGE_STATUS_FINISHED))
                        const itemStatusTranslatedUploaded = _(getStatusTranslationKey(c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE))
                        for (const oneDoc of item.dsDocuments) {
                            documentsNames.push({ name: oneDoc.documentTemplate ? oneDoc.documentTemplate.title[lang] : oneDoc.fileName, id: oneDoc._id })
                            let statusToShow = status
                            let finalTranslatedValueForStatus = itemStatusTranslated
                            if ((oneDoc.documentTemplate && oneDoc.documentTemplate.mustBeSigned) || oneDoc.origin === "DS_ORIGIN_ORACLE" || oneDoc.origin === "DS_ORIGIN_LOCAL_UPLOAD") {
                                if (item.hasFinishStatus) {
                                    finalTranslatedValueForStatus = itemStatusTranslatedSigned
                                    statusToShow = c.DS_PACKAGE_STATUS_FINISHED

                                }
                            } else {
                                if (oneDoc.uploadedToOracle) {
                                    finalTranslatedValueForStatus = itemStatusTranslatedUploaded
                                    statusToShow = c.DS_DOCUMENTS_TRANSFERRED_TO_ORACLE
                                }
                            }
                            documentsStatuses.push({ statusToShow, finalTranslatedValueForStatus, id: oneDoc._id })
                        }

                        return (<Tr
                            className={cs(trStyleArchived, styles.trFirstColumnHidden)}
                            i={item.id}
                            key={key}
                            onClick={() => { zoomTo(item) }}
                        >
                            <Td
                                column="priority"
                                value={item.priority}
                            >
                                {item.priority}
                            </Td>
                            <Td column="checkbox" value={item._id}>
                                <div style={{ width: 15 }}>
                                    <input
                                        type="checkbox"
                                        onClick={ev => ev.stopPropagation()}
                                        onChange={ev => this.check(ev, item._id)}
                                        checked={item.checked}
                                    />
                                </div>
                            </Td>
                            <Td column="createdAt">{item.createdAt && moment(item.createdAt).format("DD/MM/YYYY HH:mm:ss") || ""}
                            </Td>
                            <Td column="clientName">
                                {this.clientNameAndBrokerNumber(item)}
                            </Td>
                            <Td column="userFullName" value={item.userFullName}>
                                {item.userFullName}
                            </Td>
                            <Td column="documentLocation" value={item.uploadedOnModule}>
                                <a className={styles.goToLinkTable}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        this.navigateTo(item, false)
                                    }}
                                >
                                    {item.uploadedOnModule === c.DS_MODULE_CLIENT_CLAIMS && item.claimNumber}
                                    {item.uploadedOnModule === c.DS_MODULE_CLAIM_WIZARD && item.claimNumber}
                                    {item.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT && item.contractNumber}
                                    {item.uploadedOnModule === c.DS_MODULE_CLIENT_CONTRACT_PREM && item.contractNumber}
                                    {item.uploadedOnModule === c.DS_MODULE_CLIENT_PROFILE && item.clientNumber}
                                    {item.uploadedOnModule === c.DS_MODULE_CLIENT_TARIFICATION && item.tarificationNumber}
                                </a>
                            </Td>
                            <Td column="documentDescription">
                                {this.renderDocumentDescription(item)}
                            </Td>
                            <Td column="documentType" value={documentsNames} >
                                <div>
                                    {documentsNames.map((oneElem, key) => {
                                        return <div className={cs([styles.documentTypeSpan, 'docTypeParagraph'])} data-documentIdAttr={oneElem.id} title={oneElem.name} key={key + 'docType'}>- {oneElem.name}</div>
                                    })}
                                </div>
                            </Td>
                            <Td column="status" value={documentsStatuses}>
                                <div>
                                    {documentsStatuses.map((oneStatus, key) => {
                                        return (
                                            <p className={cs([styles.marginBot, 'statusParagraph'])} data-documentIdAttr={oneStatus.id} key={key + 'docStatus'} >
                                                <a className={cs(styles.status)}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation()
                                                        this.onItemStatusClick(oneStatus.statusToShow)
                                                    }
                                                    }>
                                                    {oneStatus.finalTranslatedValueForStatus}
                                                </a>
                                            </p>)
                                    })}
                                </div>
                            </Td>
                            <Td column="actions">
                                <div>
                                    <DsListButtonsWrapper
                                        canCreateMifid={canCreateMifid}
                                        zoomTo={zoomTo}
                                        // zoomOut={zoomOut}
                                        dsPackage={item || {}}
                                        isDsList={true}
                                        method={(dsDocument) => {
                                            return this.openLinkAndUploadWizard(dsDocument)
                                        }}
                                        sendRemindersMethod={(packageId => {
                                            return this.onResendRemindersClick(packageId)
                                        })}
                                        directSignMethod={(id) => this.onDirectSignButtonClick(id)}
                                        showInvitation={true}
                                        sendInvitationMethod={(packageId) => this.onSendInvitationClick(packageId)}
                                    />
                                </div>
                            </Td>
                        </Tr>)
                    })

                    }

                </Table>
                <Modal
                    isOpen={archiveIsOpen}
                    style={customModalStyles}
                    contentLabel={""}
                >
                    {this.archiveAllPopup()}
                </Modal>
                <Modal
                    isOpen={Boolean(statusExplainerIsOpen)}
                    style={customModalStyles}
                    contentLabel={""}
                >
                    {statusExplainerPopup(
                        _(getStatusTranslationKey(statusExplainerIsOpen)),
                        _(getStatusDescriptionTranslationKey(statusExplainerIsOpen)),
                        () => {
                            this.setState({ statusExplainerIsOpen: false })
                        },
                        _("ok")
                    )}
                </Modal>
                <Modal
                    contentLabel={""}
                    isOpen={Boolean(showUpdateWaitingModal)}
                    style={customModalStyles}
                >
                    {this.updatePackagesModalContent()}
                </Modal>

                <LinkDocumentsModal
                    modalIsOpen={!!isOpenLinkDocumentModal}
                    onCancel={() => {
                        this.setState({ isOpenLinkDocumentModal: false })
                        this.simpleRefresh()
                    }}
                    onConfirmation={() => {
                        this.setState({ isOpenLinkDocumentModal: false })
                        this.simpleRefresh()
                    }}
                    flag={'LinkDocumentModal'}
                    payload={isOpenLinkDocumentModal ?
                        {
                            dsPackage: isOpenLinkDocumentModal
                        } : {}
                    }
                />

                <ReminderEmailStatusDialog
                    isOpen={reminderConfirmationModal}
                    success={reminderSentSuccessFlag}
                    invitationBlocked={invitationBlocked}
                    closeModal={() => this.setState({ reminderConfirmationModal: false })}
                />

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/documentsList.jsx